<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div>
          <el-row>
            <el-col :span="6">
              <span>课程类型:</span>
              <span v-if="dataIn.isCompleted">{{ courseTypeText }}</span>
              <el-select v-else v-model="courseType" size="medium" placeholder="请选择课程类型" class="cs-discount-select" @change="onCourseTypeChange">
                <el-option v-for="item in courseTypeList" :key="item.Key" :label="item.Value" :value="item.Key">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="12">
              <el-row v-if="!dataIn.isCompleted && this.courseType == 1" class="cs-relatedInTerm">
                <el-col>
                  <span>优惠类型: &nbsp;&nbsp;&nbsp;</span>
                  <span v-if="dataIn.isCompleted">{{
                      getSelectedDiscountTypeName()
                    }}</span>
                  <el-select v-else v-model="discountType" size="medium" placeholder="请选择优惠类型" class="cs-discount-select" @change="onDiscountTypeChange">
                    <el-option v-for="item in discountTypes" :key="item.key" :label="item.value" :value="item.key">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <div v-show="this.courseType == 1 && discountType === 0">
                    <!-- <el-checkbox v-model="hasRelatedWorkflow"
                      @change="relatedWorkflowEqualCheckChange">课程连报(等折扣)</el-checkbox>
                    <el-checkbox v-model="hasRelatedWorkflowNotEqual"
                      @change="hasRelatedWorkflowNotEqualCheckChange">课程连报(不等折扣)</el-checkbox>
                    <el-checkbox v-model="hasRelatedWorkflowAllowance"
                      @change="hasRelatedWorkflowAllowanceCheckChange">课程连报(补贴)</el-checkbox>
                    <el-checkbox v-model="hasRelatedWorkflowNotEqualWithAllowance"
                      @change="hasRelatedWorkflowNotEqualWithAllowanceCheckChange">课程连报(不等折扣+补贴)</el-checkbox> -->
                    <span>课程连报优惠:</span>
                    <span v-if="dataIn.isCompleted">{{
                      getSelectedRelatedInTermDiscountName()
                    }}</span>
                    <el-select v-else v-model="selectedRelatedInTermDiscountId" size="medium" placeholder="请选择课程连报优惠" class="cs-discount-select"
                      @input="onDiscountsInput" @change="onRelatedInTermDDiscountsChange">
                      <el-option key="" value="">无</el-option>
                      <el-option v-for="item in relatedInTermDiscountListDisplayed" :key="item.Id" :label="item.LabelName" :value="item.Id">
                      </el-option>
                    </el-select>
                  </div>
                  <div v-show="discountType === 1">
                    <span>其他优惠政策:</span>
                    <span v-if="dataIn.isCompleted">{{
                      getSelectedNormalDiscountName()
                    }}</span>
                    <el-select v-else v-model="selectedNormalDiscountIdList" size="medium" placeholder="请选择优惠政策" class="cs-discount-select" multiple
                      @input="onDiscountsInput" @change="onDiscountsChange">
                      <el-option v-for="item in normalDiscountListDisplayed" :key="item.Id" :label="item.LabelName" :value="item.Id">
                      </el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="4">
              <el-button v-if="!dataIn.isCompleted" class="cs-workflow-addCourse" type="primary" plain icon="el-icon-plus"
                @click="onAddCourse">添加/编辑课程</el-button>
            </el-col>
          </el-row>
        </div>
        <div>
          <relatedWorkflowList ref="relatedWorkflowList" v-if="this.courseType == 1" :dataIn="relatedWorkflowData" :isReadonly="dataIn.isCompleted"
            v-show="hasRelatedWorkflow" @selectedWorkflowChange="selectedWorkflowChange"></relatedWorkflowList>
        </div>
        <div>
          <courseEnrollmentList v-if="isDisplayCourseList" ref="courseEnrollmentList" :bonusPointDisabled="bonusPointDisabled" :courseType="courseType"
            :bonusPoint="bonusPoint" :priceSettings="dataIn.priceSettings" :vipCourseAliasList="dataIn.vipCourseAliasList" :isReadonly="dataIn.isCompleted"
            :dataIn="dataIn.courseListData" :studentId="dataIn.studentId" :isCalculating="isCalculating" @calculate="onCalculate"></courseEnrollmentList>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="添加编辑课程" :center="true" :close-on-click-modal="false" width="70%" :visible.sync="selectCourseDialogVisible" top="3vh">
      <selectCourseDialog :courseType="courseType" :dataIn="courseData" @closeDialog="onCloseDialog" @saveSuccess="onSaveSuccess"></selectCourseDialog>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.stepContent {
  padding: 20px;
}

.cs-workflow-addCourse {
  margin-left: 10px;
}

.cs-discount-select {
  width: 60%;
}

.cs-relatedInTerm {
  margin-bottom: 5px;
}
</style>

<script>
import {
  getCourseTypeText,
  getCourseTypeList,
  getAccountTypeByCourseType,
} from "../../../config/mUtils";
import { getFormulaListByType } from "../../../service/finance.service";
import {
  getSupplementVideoTypeList,
  getWeChatGroupTypeList,
  getCampusTaxRateList,
} from "../../../service/common.service";
import { getFreeTrialCourseListForEnroll } from "@/service/enrollmentFee.service";
import selectCourseDialog from "./selectCourseDialog";
import relatedWorkflowList from "./relatedWorkflowList";
import courseEnrollmentList from "./courseEnrollmentList";
import bonusPointMechanismVue from "../../../page/admin/bonusPointMechanism.vue";

export default {
  props: {
    isCalculating: Boolean,
    bonusPointDisabled: Boolean,
    dataIn: {
      studentId: Number,
      workflowId: Number,
      isCompleted: Boolean,
      courseType: Number,
      hasBuyMemberCard: Boolean,
      universityGroupNumber: Number,
      universityGroupText: String,
      bonusPoint: Number,
      priceSettings: Object,
      selectedDiscountList: Array,
      courseListData: Object,
      relatedIdList: Array,
      relatedWorkflowType: Number,
      comment: String,
      taxModel: Object,
      vipCourseAliasList: Array,
    },
  },
  data() {
    return {
      discountList: [],
      selectCourseDialogVisible: false,
      courseData: {
        universityCourseData: {},
        trainingCourseData: {},
        englishCourseData: {},
      },
      courseListData: {
        termId: 0,
        enrollmentAvailableCount: 0,
        trainingEnrollmentAvailableCount: 0,
        courseList: [],
        studentAdvanceEnrollmentList: [],
        studentAdvanceEnrollmentAdditional: "",
      },
      isDisplayCourseList: false,
      courseTypeList: [],
      courseType: 1,
      courseTypeText: "",
      bonusPoint: 0,
      normalDiscountListDisplayed: [],
      relatedInTermDiscountListDisplayed: [],
      hasRelatedWorkflow: false, //课程连报(等折扣)
      hasRelatedWorkflowNotEqual: false, //课程连报(不等折扣)
      hasRelatedWorkflowAllowance: false, //课程连报(补贴))
      hasRelatedWorkflowNotEqualWithAllowance: false, //课程连报(不等折扣+补贴))
      relatedWorkflowData: {},
      campusTaxRateList: [],
      selectedNormalDiscountIdList: [],
      selectedRelatedInTermDiscountId: "",
      discountType: 0,
      discountTypes: [
        { key: 0, value: "课程连报" },
        { key: 1, value: "其他优惠" },
      ],
    };
  },
  components: {
    selectCourseDialog,
    courseEnrollmentList,
    relatedWorkflowList,
  },
  computed: {},
  created() {
    this.courseTypeList = getCourseTypeList(false, true);

    getCampusTaxRateList().then((result) => {
      if (!!result && result.success) {
        this.campusTaxRateList = result.data;
      }
    });
    this.init();
  },
  methods: {
    init() {
      if (!!this.dataIn && !!this.dataIn.courseListData) {
        if (
          !!this.dataIn.courseListData.courseList &&
          this.dataIn.courseListData.courseList.length > 0
        ) {
          this.isDisplayCourseList = true;
        }
        this.courseType = this.dataIn.courseType;
        this.bonusPoint = this.dataIn.bonusPoint;
        this.courseListData = this.dataIn.courseListData;
        this.hasRelatedWorkflow = false;

        if (!!this.dataIn.relatedWorkflowType) {
          if (this.dataIn.relatedWorkflowType == 1) {
            this.hasRelatedWorkflow = true;
          } else if (this.dataIn.relatedWorkflowType == 2) {
            this.hasRelatedWorkflowNotEqual = true;
          } else if (this.dataIn.relatedWorkflowType == 3) {
            this.hasRelatedWorkflowAllowance = true;
          } else if (this.dataIn.relatedWorkflowType == 4) {
            this.hasRelatedWorkflowNotEqualWithAllowance = true;
          }
          this.showRelatedWorkflow();
        }
        this.getCourseDialogData();
      } else {
        this.courseListData = {
          termId: 0,
          enrollmentAvailableCount: 0,
          trainingEnrollmentAvailableCount: 0,
          courseList: [],
        };
        this.courseType = 1;
        this.bonusPoint = 0;
        this.courseData = {
          universityCourseData: {},
          trainingCourseData: {},
          englishCourseData: {},
        };
        this.hasRelatedWorkflow = false;
        this.hasRelatedWorkflowNotEqual = false;
        this.hasRelatedWorkflowAllowance = false;
        this.hasRelatedWorkflowNotEqualWithAllowance = false;
      }
      this.courseTypeText = getCourseTypeText(this.courseType);
      this.getDiscountList();
    },
    relatedWorkflowEqualCheckChange() {
      this.relatedWorkflowCheckChange(1);
    },
    hasRelatedWorkflowNotEqualCheckChange() {
      this.relatedWorkflowCheckChange(2);
    },
    hasRelatedWorkflowAllowanceCheckChange() {
      this.relatedWorkflowCheckChange(3);
    },
    hasRelatedWorkflowNotEqualWithAllowanceCheckChange() {
      this.relatedWorkflowCheckChange(4);
    },
    relatedWorkflowCheckChange(relatedWorkflowType) {
      this.refreshDiscountListForRelatedWorkflow(relatedWorkflowType);
      let isSelected = this.getRelatedWorkflowSelected(relatedWorkflowType);

      if (isSelected) {
        let relatedWorkflowTypeList = [1, 2, 3, 4];
        for (let i = 0; i < relatedWorkflowTypeList.length; i++) {
          let currentType = relatedWorkflowTypeList[i];
          if (currentType !== relatedWorkflowType) {
            this.setRelatedWorkflowSelected(currentType, false);
            this.selectRelatedWorkflowDiscount(currentType, false);
          }
        }
        this.showRelatedWorkflow();
      } else {
        if (!!this.$refs["relatedWorkflowList"]) {
          this.$refs["relatedWorkflowList"].clearSelection();
        }
      }

      this.$nextTick(() => {
        this.triggerCalculate();
      });
    },
    selectAdvanceEnrollmentForDiscount(isSelected) {
      if (isSelected) {
        this.dataIn.courseListData.studentAdvanceEnrollmentList.forEach((x) => {
          x.Used = false;
        });
      }

      this.$refs.courseEnrollmentList.selectAdvanceEnrollmentForDiscount(
        isSelected
      );
    },
    showRelatedWorkflow() {
      if (!!this.dataIn) {
        let relatedWorkflowType = this.getRelatedWorkflowType();
        this.relatedWorkflowData = {
          workflowId: this.dataIn.workflowId,
          studentId: this.dataIn.studentId,
          termId: this.courseListData.termId,
          relatedIdList: this.dataIn.relatedIdList,
          taxModel: this.dataIn.taxModel,
          relatedWorkflowType: relatedWorkflowType,
          relatedInTermDiscountId: this.selectedRelatedInTermDiscountId,
        };
      }
    },
    isDisplayDiscount(item) {},
    onCalculate() {
      this.triggerCalculate();
    },
    getCourseDialogData() {
      let universityCourseData = {
        universityGroupNumber: this.dataIn.universityGroupNumber,
        universityGroupText: this.dataIn.universityGroupText,
        termId: 0,
        selectedCourseIdList: [],
      };

      let trainingCourseData = {
        termId: 0,
        categoryId: 0,
        campusId: 0,
        selectedCourseIdList: [],
      };

      let englishCourseData = {
        termId: 0,
        categoryId: 0,
        campusId: 0,
        selectedCourseIdList: [],
      };

      let newStudentGuideCourseData = {
        termId: 0,
        categoryId: 0,
        campusId: 0,
        selectedCourseIdList: [],
      };

      if (!!this.courseListData) {
        universityCourseData.termId = this.courseListData.termId;

        trainingCourseData.termId = this.courseListData.termId;
        trainingCourseData.categoryId = this.courseListData.categoryId;

        englishCourseData.categoryId = this.courseListData.categoryId;
        newStudentGuideCourseData.categoryId = this.courseListData.categoryId;

        if (this.courseListData.courseList.length > 0) {
          trainingCourseData.campusId =
            this.courseListData.courseList[0].campusId;
          englishCourseData.campusId =
            this.courseListData.courseList[0].campusId;
          newStudentGuideCourseData.campusId =
            this.courseListData.courseList[0].campusId;

          this.courseListData.courseList.forEach((element) => {
            if (element.courseType == 1) {
              universityCourseData.selectedCourseIdList.push(element.courseId);
            } else if (element.courseType == 2) {
              englishCourseData.selectedCourseIdList.push(element.courseId);
            } else if (element.courseType == 3) {
              trainingCourseData.selectedCourseIdList.push(element.courseId);
            } else if (element.courseType == 4) {
              newStudentGuideCourseData.selectedCourseIdList.push(
                element.courseId
              );
            }
          });
        }
      }
      this.courseData = {
        universityCourseData: universityCourseData,
        trainingCourseData: trainingCourseData,
        englishCourseData: englishCourseData,
        newStudentGuideCourseData: newStudentGuideCourseData,
      };
    },
    onCloseDialog() {
      this.selectCourseDialogVisible = false;
    },
    onSaveSuccess(value) {
      this.selectCourseDialogVisible = false;
      if (this.courseType == 1) {
        if (
          !!value &&
          !!value.universityCourseData &&
          !!value.universityCourseData.selectedCourseList
        ) {
          let list = [];

          value.universityCourseData.selectedCourseList.forEach((element) => {
            let courseId = element.Id;
            let existingCourse = this.courseListData.courseList.filter(
              (i) => i.courseId == courseId
            );
            if (existingCourse.length > 0) {
              existingCourse[0].termId = value.universityCourseData.termId;
              existingCourse[0].termText = value.universityCourseData.termText;
              existingCourse[0].categoryId =
                value.universityCourseData.categoryId;
              existingCourse[0].categoryText =
                value.universityCourseData.categoryText;
              existingCourse[0].campusId = campusId;
              existingCourse[0].campusText =
                value.universityCourseData.campusText;

              list.push(existingCourse[0]);
            } else {
              let itemData = this.getCourseItem(
                value.universityCourseData,
                element
              );
              list.push(itemData);
            }
          });
          this.isDisplayCourseList = true;
          this.$set(
            this.courseListData,
            "termId",
            value.universityCourseData.termId
          );
          let campusId =
            value.universityCourseData.selectedCourseList.length > 0 &&
            value.universityCourseData.selectedCourseList[0].CampusList.length >
              0
              ? value.universityCourseData.selectedCourseList[0].CampusList[0]
              : 0;
          this.setTaxRate(campusId);
          this.$set(this.courseListData, "courseList", list);
          this.showRelatedWorkflow();
        }
      } else if (this.courseType == 2) {
        if (
          !!value &&
          !!value.englishCourseData &&
          !!value.englishCourseData.selectedCourseList
        ) {
          let list = [];

          value.englishCourseData.selectedCourseList.forEach((element) => {
            let courseId = element.Id;
            let existingCourse = this.courseListData.courseList.filter(
              (i) => i.courseId == courseId
            );
            if (existingCourse.length > 0) {
              existingCourse[0].categoryId = value.englishCourseData.categoryId;
              existingCourse[0].categoryText =
                value.englishCourseData.categoryText;
              existingCourse[0].campusId = value.englishCourseData.campusId;
              existingCourse[0].campusText = value.englishCourseData.campusText;
              list.push(existingCourse[0]);
            } else {
              let itemData = this.getCourseItem(
                value.englishCourseData,
                element
              );
              list.push(itemData);
            }
          });
          this.setTaxRate(value.englishCourseData.campusId);
          this.isDisplayCourseList = true;
          this.$set(this.courseListData, "courseList", list);
        }
      } else if (this.courseType == 4) {
        if (
          !!value &&
          !!value.newStudentGuideCourseData &&
          !!value.newStudentGuideCourseData.selectedCourseList
        ) {
          let list = [];

          value.newStudentGuideCourseData.selectedCourseList.forEach(
            (element) => {
              let courseId = element.Id;
              let existingCourse = this.courseListData.courseList.filter(
                (i) => i.courseId == courseId
              );
              if (existingCourse.length > 0) {
                existingCourse[0].categoryId =
                  value.newStudentGuideCourseData.categoryId;
                existingCourse[0].categoryText =
                  value.newStudentGuideCourseData.categoryText;
                existingCourse[0].campusId =
                  value.newStudentGuideCourseData.campusId;
                existingCourse[0].campusText =
                  value.newStudentGuideCourseData.campusText;
                list.push(existingCourse[0]);
              } else {
                let itemData = this.getCourseItem(
                  value.newStudentGuideCourseData,
                  element
                );
                list.push(itemData);
              }
            }
          );
          this.setTaxRate(value.newStudentGuideCourseData.campusId);
          this.isDisplayCourseList = true;
          this.$set(this.courseListData, "courseList", list);
        }
      } else if (this.courseType == 3) {
        if (
          !!value &&
          !!value.trainingCourseData &&
          !!value.trainingCourseData.selectedCourseList
        ) {
          let list = [];

          value.trainingCourseData.selectedCourseList.forEach((element) => {
            let courseId = element.Id;
            let existingCourse = this.courseListData.courseList.filter(
              (i) => i.courseId == courseId
            );
            if (existingCourse.length > 0) {
              existingCourse[0].termId = value.trainingCourseData.termId;
              existingCourse[0].termText = value.trainingCourseData.termText;
              existingCourse[0].categoryId =
                value.trainingCourseData.categoryId;
              existingCourse[0].categoryText =
                value.trainingCourseData.categoryText;
              existingCourse[0].campusId = value.trainingCourseData.campusId;
              existingCourse[0].campusText =
                value.trainingCourseData.campusText;
              list.push(existingCourse[0]);
            } else {
              let itemData = this.getCourseItem(
                value.trainingCourseData,
                element
              );
              list.push(itemData);
            }
          });
          this.isDisplayCourseList = true;
          this.setTaxRate(value.trainingCourseData.campusId);
          this.$set(
            this.courseListData,
            "termId",
            value.trainingCourseData.termId
          );

          this.$set(this.courseListData, "courseList", list);
        }
      }
      //this.triggerCalculate();
    },
    setTaxRate(campusId) {
      let taxRate = this.getCampusTaxRate(campusId);
      if (typeof taxRate == "undefined") {
        taxRate = 0;
      }
      this.$set(this.dataIn.taxModel, "taxRate", taxRate);
    },
    getCourseItem(courseData, element) {
      let itemData = {
        modelData: {
          isAdvanceEnrollmentPrice: false,
          isInternalPrice: false,
          isOriginalPrice: false,
          isFreeTrial: false,
          isVideoFree: false,
          isAiCourseEnabled: false,
          isEnsureACourse: false,
          startWeek: 0,
          categoryId: 0,
          categoryOptionId: 0,
          vipCoursePriceId: null,
          courseCount: 1,
          courseMinutes: 0,
          supplementVideoType: 3,
          supplementVideoCount: 0,
          contractId: !!element.ContractId ? element.ContractId : 0,
          hasContractAgreed: false,
          contractFiles: [],
          weChatGroupType: 0,
          comment: "",
          selectedStudentAdvanceEnrollmentId: 0,
          yearCourseType: 0,
          courseAlias: "",
          reviewCourseStart: null,
          reviewCourseEnd: null,
        },
        priceData: {
          price: 0,
          discountPrice: 0,
          subtotal: 0,
          supplementVideoPrice: 0,
          bonusPointCost: 0,
          bonusPointAmount: 0,
          cashDecreasedAmount: 0,
          oldBonusPointCost: 0,
          couponCode: "",
          couponDiscountDollar: 0,
          couponDiscountPrice: 0,
        },
        courseId: element.Id,
        courseName: element.Name,
        courseType: courseData.courseType,
        courseTypeText: getCourseTypeText(courseData.courseType),
        universityGroup: courseData.universityGroupNumber,
        universityGroupText: courseData.universityGroupText,
        termId: courseData.termId,
        termText: courseData.termText,
        categoryId: courseData.categoryId,
        categoryText: courseData.categoryText,
        campusId: courseData.campusId,
        campusText: courseData.campusText,
        isRefund: false,
        isHourPrice: false,
        isYearCourse: element.IsYearCourse,
        yearCourseTypeWithWeek: element.YearCourseTypeWithWeek,
        defaultContractId: element.ContractId,
      };

      if (courseData.courseType == 2 || courseData.courseType == 4) {
        itemData.isHourPrice = element.IsHourPrice;
        itemData.modelData.courseCount = 2;
      }

      if (courseData.courseType == 1) {
        itemData.modelData.supplementVideoType = 0;
        if (element.CourseCategory) {
          itemData.modelData.categoryId = element.CourseCategory;
        }
      }
      return itemData;
    },
    onAddCourse() {
      this.selectCourseDialogVisible = true;
    },
    getDiscountList() {
      let accountType = getAccountTypeByCourseType(this.courseType);
      getFormulaListByType(1, accountType).then((result) => {
        if (!!result && result.success) {
          this.discountList = result.data;
          this.getDiscountListDisplayed();
        }
      });
    },
    getDiscountListDisplayed() {
 
      let normalDiscountList = [];
      let relatedInTermDiscountList = [];

      let normalDiscountIdList = [];
      let relatedInTermDiscountId = "";
      this.discountList.forEach((item) => {
        if (
          (item.MapVariableName == "MembershipCardDiscountPrice" &&
            this.dataIn.hasBuyMemberCard) ||
          item.MapVariableName != "MembershipCardDiscountPrice"
        ) {
          let isAdd = false;
          if (this.courseType == 1) {
            if (
              !item.UniversityGroups ||
              item.UniversityGroups.length == 0 ||
              item.UniversityGroups.indexOf(
                this.dataIn.universityGroupNumber
              ) >= 0
            ) {
              isAdd = true;
            }
          } else {
            isAdd = true;
          }

          if (isAdd) {
            if (this.courseType == 1 && item.IsRelatedInTerm) {
              relatedInTermDiscountList.push(item);
              if (
                this.dataIn.selectedDiscountList &&
                this.dataIn.selectedDiscountList.indexOf(item.Id) >= 0
              ) {
                relatedInTermDiscountId = item.Id;
              }
            } else {
              normalDiscountList.push(item);
              if (
                this.dataIn.selectedDiscountList &&
                this.dataIn.selectedDiscountList.indexOf(item.Id) >= 0
              ) {
                normalDiscountIdList.push(item.Id);
              }
            }
          }
        }
      });

      this.normalDiscountListDisplayed = normalDiscountList;
      this.relatedInTermDiscountListDisplayed = relatedInTermDiscountList;

      this.selectedNormalDiscountIdList = normalDiscountIdList;
      this.selectedRelatedInTermDiscountId = relatedInTermDiscountId;
      if (this.courseType == 1) {
        if (this.selectedNormalDiscountIdList.length > 0) {
          this.discountType = 1;
        } else {
          this.discountType = 0;
        }
      } else {
        this.discountType = 1;
      }
      this.checkRelatedWorkflowDiscount();
    },
    getSelectedDiscountTypeName() {
      let item = this.discountTypes.find((i) => i.key === this.discountType);
      return item.value;
    },
    getSelectedRelatedInTermDiscountName() {
      if (!this.selectedRelatedInTermDiscountId) {
        return "";
      }
      let list = [this.selectedRelatedInTermDiscountId];
      return this.getSelectedDiscountNames(list);
    },
    getSelectedNormalDiscountName() {
      return this.getSelectedDiscountNames(this.selectedNormalDiscountIdList);
    },
    getAllSelectedDiscountName() {
      return this.getSelectedDiscountNames(this.getSelectedDiscountIds());
    },
    getSelectedDiscountNames(ids) {
      if (!ids || !ids.length) {
        return "";
      }
      let selectedNames = this.discountList
        .filter((i) => ids.indexOf(i.Id) >= 0)
        .map((i) => i.LabelName);

      return selectedNames.join(",");
    },
    getSelectedDiscountIds() {
      let list = JSON.parse(JSON.stringify(this.selectedNormalDiscountIdList));
      if (this.selectedRelatedInTermDiscountId) {
        list.push(this.selectedRelatedInTermDiscountId);
      }
     
      return list;
    },
    getSelectedCourseType() {
      return this.courseType;
    },
    onDiscountsChange() {
      //连报优惠
      // if (this.courseType == 1) {
      //   this.checkRelatedWorkflowDiscount(1);
      //   this.checkRelatedWorkflowDiscount(2);
      //   this.checkRelatedWorkflowDiscount(3);
      //   this.checkRelatedWorkflowDiscount(4);
      // }

      this.triggerCalculate();
    },
    onDiscountTypeChange() {
      this.selectedNormalDiscountIdList = [];
      this.selectedRelatedInTermDiscountId = "";
      this.triggerCalculate();
    },
    onRelatedInTermDDiscountsChange() {
      this.checkRelatedWorkflowDiscount();
      this.triggerCalculate();
    },
    checkRelatedWorkflowDiscount() {
      if (this.selectedRelatedInTermDiscountId) {
        this.hasRelatedWorkflow = true;
        this.showRelatedWorkflow();
      } else {
        this.hasRelatedWorkflow = false;
      }
    },
    // checkRelatedWorkflowDiscount(relatedWorkflowType) {
    //   let name = this.getRelatedWorkflowDiscountName(relatedWorkflowType);
    //   let formula = this.discountList.find(
    //     (i) => i.VariableName.indexOf(name) == 0
    //   );
    //   if (!!formula && !!formula.Id) {
    //     let index = this.dataIn.selectedDiscountList.indexOf(formula.Id);
    //     let isSelected = index >= 0;
    //     this.setRelatedWorkflowSelected(relatedWorkflowType, isSelected);

    //     if (isSelected) {
    //       this.showRelatedWorkflow();
    //     }
    //   }
    // },
    onDiscountsInput() {},
    triggerCalculate() {
      this.$emit("calculate");
    },
    onCourseTypeChange() {
      this.courseTypeText = getCourseTypeText(this.courseType);
      this.dataIn.selectedDiscountList = [];
      this.selectedNormalDiscountIdList = [];
      this.selectedRelatedInTermDiscountId = "";
      this.hasRelatedWorkflow = false;
      this.getDiscountList();
      this.$set(this.courseListData, "courseList", []);
    },
    getSelectedWorkflow() {
      if (!!this.$refs["relatedWorkflowList"]) {
        return this.$refs["relatedWorkflowList"].getSelectedWorkflow();
      }
      return [];
    },
    refreshDiscountListForRelatedWorkflow(relatedWorkflowType) {
      if (this.courseType == 1) {
        let isSelected = this.getRelatedWorkflowSelected(relatedWorkflowType);
        this.selectRelatedWorkflowDiscount(relatedWorkflowType, isSelected);
      }
    },
    getRelatedWorkflowSelected(relatedWorkflowType) {
      let isSelected = false;
      switch (relatedWorkflowType) {
        case 1: {
          isSelected = this.hasRelatedWorkflow;
          break;
        }
        case 2: {
          isSelected = this.hasRelatedWorkflowNotEqual;
          break;
        }
        case 3: {
          isSelected = this.hasRelatedWorkflowAllowance;
          break;
        }
        case 4: {
          isSelected = this.hasRelatedWorkflowNotEqualWithAllowance;
          break;
        }
      }
      return isSelected;
    },
    setRelatedWorkflowSelected(relatedWorkflowType, isSelected) {
      switch (relatedWorkflowType) {
        case 1: {
          this.hasRelatedWorkflow = isSelected;
          break;
        }
        case 2: {
          this.hasRelatedWorkflowNotEqual = isSelected;
          break;
        }
        case 3: {
          this.hasRelatedWorkflowAllowance = isSelected;
          break;
        }
        case 4: {
          this.hasRelatedWorkflowNotEqualWithAllowance = isSelected;
          break;
        }
      }
    },
    selectRelatedWorkflowDiscount(relatedWorkflowType, isSelected) {
      let name = this.getRelatedWorkflowDiscountName(relatedWorkflowType);
      name = name + "{Index}";

      let formula = this.discountList.find((i) => i.VariableName == name);
      if (!!formula && !!formula.Id) {
        let index = this.dataIn.selectedDiscountList.indexOf(formula.Id);
        if (isSelected) {
          if (index < 0) {
            this.dataIn.selectedDiscountList.push(formula.Id);
          }
        } else {
          if (index >= 0) {
            this.dataIn.selectedDiscountList.splice(index, 1);
          }
        }
      }
    },
    selectedWorkflowChange() {
      this.triggerCalculate();
    },
    getCampusTaxRate(campusId) {
      if (!!this.campusTaxRateList) {
        let item = this.campusTaxRateList.find((i) => i.CampusId == campusId);
        if (!!item) {
          return item.TaxRate;
        }
      }
      return 0;
    },
    getRelatedWorkflowType() {
      if (this.hasRelatedWorkflow) {
        return 1;
      } else if (this.hasRelatedWorkflowNotEqual) {
        return 2;
      } else if (this.hasRelatedWorkflowAllowance) {
        return 3;
      } else if (this.hasRelatedWorkflowNotEqualWithAllowance) {
        return 4;
      } else {
        return null;
      }
    },
    getRelatedWorkflowDiscountName(relatedWorkflowType) {
      if (relatedWorkflowType == 1) {
        return "CourseRelatedInTerm";
      } else if (relatedWorkflowType == 2) {
        return "CourseRelatedInTermNotEqual";
      } else if (relatedWorkflowType == 3) {
        return "CourseRelatedInTermAllowance";
      } else if (relatedWorkflowType == 4) {
        return "CourseRelatedInTermNotEqualWithAllowance";
      }
      return "";
    },
    async initCourseListForEnrollFreeTrial(studentId) {
      this.courseType = 1;

      try {
        let result = await getFreeTrialCourseListForEnroll(studentId);
        if (!!result && result.success && result.data.Courses.length > 0) {
          let campusList =
            result.Courses.length > 0 ? result.Courses[0].CampusList || [] : [];
          let courseData = {
            courseType: this.courseType,
            termId: result.data.TermId,
            termText: result.data.TermText,
            universityGroupNumber: this.dataIn.universityGroupNumber,
            universityGroupText: this.dataIn.universityGroupText,
            campusId: campusList.length > 0 ? campusList[0] : 0,
          };
          let list = [];
          result.data.Courses.forEach((element) => {
            let itemData = this.getCourseItem(courseData, element);
            list.push(itemData);
          });

          this.isDisplayCourseList = true;
          this.$set(this.courseListData, "termId", courseData.termId);
          this.setTaxRate(courseData.campusId);
          this.$set(this.courseListData, "courseList", list);
          //this.showRelatedWorkflow();
        }
      } catch (error) {}
    },
  },
  watch: {
    dataIn: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/courseEnrollmentFee/workflowStep2.vue